import MlStudioPage from '../pages/MlStudioPage'

export default [
  {
    name: 'MlStudio',
    path: '/infinity-ai',
    component: MlStudioPage,
    meta: {
      features: ['mlStudioAccessible']
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/ml-studio/router/index.js